export default {
    title: '{school} ชั้นปีที่ {grade} ห้อง {className} <span>({onlineCount}/{totalCount})</span>',
    onlineCount: 'กำลังเข้าร่วมคาบเรียน <span>({count} คน)</span>',
    offlineCount: 'ยังไม่เข้าร่วม <span>({count} คน)</span>',
    selectedStudents: 'เลือกแล้ว {count} คน',
    giveStar: ({ values }: { values: { isAll: boolean } }) => {
        const { isAll } = values;

        if (isAll) {
            return 'ให้ดาวแก่<span>นักเรียนทุกคน</span>';
        }

        return '<span>ให้ดาว</span>';
    },
    giveStarConfirm: 'จะให้ดาวชมเชยแก่<strong>{label}</strong>ไหม?',
    comment: {
        '0': 'ทำได้ดีมาก',
        '1': 'มีส่วนร่วมอย่างกระตือรือร้น',
        '2': 'ร่วมมือกับเพื่อนได้ดี',
        '3': 'อธิบายได้ดี',
        '4': 'ตอบอย่างมีเหตุผล',
        '5': 'แสดงออกได้ยอดเยี่ยม',
        '6': 'นำเสนอได้ดี',
        '7': 'เป็นคำตอบที่แปลกใหม่',
        '8': 'ความคิดสร้างสรรค์โดดเด่น',
    },
};
